import React, { lazy, Suspense } from 'react';
import { Account, User } from '@citrite/sf-api';
import { LoadingPrimary } from '@sharefiledev/flow-web';

interface RenderConditionallyProps {
	account: Account;
	user: User;
	sendForSignatureEntitlement: boolean;
	children: React.ReactNode;
}

const LazyRenderConditionally = lazy(() => import('./RenderConditionally'));
export const AsyncRenderConditionally: React.FC<RenderConditionallyProps> = props => (
	<Suspense fallback={<LoadingPrimary />}>
		<LazyRenderConditionally {...props} />
	</Suspense>
);
